import { create } from "zustand";

import SearchApiCaller from "../config/api/searchapicaller";
import { readMapCache, writeMapCache } from "./cache";

const UNIVERSITY_TTL = 24 * 60 * 60 * 1000;

const cacheStore = {
  universities: new Map(),
};

const initialState = {
  universities: [],
  count: 0,
  isLoading: false,
  error: null,
};

export const useUniversityStore = create((set) => {
  const setUniversities = (partial) =>
    set((state) => ({ ...state, ...partial }));

  return {
    ...initialState,
    getUniversities: async (payload, cb) => {
      try {
        setUniversities({ isLoading: true, error: null });
        const cacheKey = JSON.stringify(payload ?? {});
        const cached = readMapCache(cacheStore.universities, cacheKey);
        if (cached) {
          setUniversities({
            universities: cached.data,
            count: cached.total,
            isLoading: false,
          });
          if (cb) cb({ data: cached });
          return;
        }
        const res = await SearchApiCaller.Post("/search/getuniversity", payload);
        if (res?.status === 200) {
          setUniversities({
            universities: res.data?.data,
            count: res.data?.total,
            isLoading: false,
          });
          writeMapCache(cacheStore.universities, cacheKey, res.data, UNIVERSITY_TTL);
        } else {
          setUniversities({ isLoading: false });
        }
        if (cb) cb(res?.data);
      } catch (err) {
        setUniversities({ isLoading: false, error: err });
      }
    },
    reset: () => set(initialState),
  };
});
